import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchTrialData,
  batchUpdateOpnBal,
  fetchOutstandingDocuments,
  saveOutstandingDocuments,
} from "services/opnbal";
import useAuthStore from "store/auth";

export const useTrialData = (type, code = null) => {
  const { agttp } = useAuthStore();
  
  const query = useQuery({
    queryKey: ["trial-data", type, code],
    queryFn: () => {
      // For agttp=1 (trader), only type is needed
      // For agttp=0 (agent), both type and code are needed
      if (agttp === 1 && type) {
        return fetchTrialData(type);
      } else if (agttp === 0 && type && code) {
        return fetchTrialData(type, code);
      }
      return Promise.resolve([]);
    },
    enabled: agttp === 1 ? !!type : !!(type && code),
    staleTime: 0, // Always fetch fresh data when vendor/customer changes
  });
  return query;
};

export const useBatchUpdateOpnBal = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => batchUpdateOpnBal(data),
    onSuccess: (data) => {
      // Invalidate trial data queries to refresh the table
      queryClient.invalidateQueries({ queryKey: ["trial-data"] });
    },
  });
};

export const useOutstandingDocuments = (vendorId, customerId, enabled = true) => {
  const query = useQuery({
    queryKey: ["outstanding-documents", vendorId, customerId],
    queryFn: () => {
      if (vendorId && customerId) {
        return fetchOutstandingDocuments(vendorId, customerId);
      }
      return Promise.resolve([]);
    },
    enabled: enabled && !!vendorId && !!customerId,
    staleTime: 0,
  });
  return query;
};

export const useSaveOutstandingDocuments = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => saveOutstandingDocuments(data),
    onSuccess: (data) => {
      // Invalidate outstanding documents queries to refresh the data
      queryClient.invalidateQueries({ queryKey: ["outstanding-documents"] });
    },
  });
};
